(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/components/communication-settings-skeleton.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/communication-settings/communication-settings-panel/components/communication-settings-skeleton.js');
'use strict';

const {
  TopHeader
} = svs.myProfile.react.shared.components;
const {
  Skeleton
} = svs.myProfile.react.shared.components;
const {
  titles,
  icons
} = svs.myProfile.constants;

const CommunicationSettingsSkeleton = () => React.createElement(React.Fragment, null, React.createElement(TopHeader, {
  icon: icons.HELP,
  title: titles.HELP
}), React.createElement(Skeleton, {
  bottomMargin: 0,
  boxHeight: 8,
  boxWidthProcent: 100,
  topMargin: 2
}), React.createElement(Skeleton, {
  bottomMargin: 1,
  boxHeight: 2,
  boxWidthProcent: 100,
  topMargin: 1
}), React.createElement("div", {
  className: "margin-top-2"
}, React.createElement(TopHeader, {
  icon: icons.NEWS,
  title: titles.NEWS
}), React.createElement(Skeleton, {
  bottomMargin: 1,
  boxHeight: 2,
  boxWidthProcent: 100,
  topMargin: 2
}), React.createElement(Skeleton, {
  bottomMargin: 1,
  boxHeight: 3,
  boxWidthProcent: 100,
  topMargin: 2
}), React.createElement(Skeleton, {
  bottomMargin: 1,
  boxHeight: 1,
  boxWidthProcent: 100,
  topMargin: 1
}), React.createElement(Skeleton, {
  bottomMargin: 1,
  boxHeight: 1,
  boxWidthProcent: 100,
  topMargin: 1
}), React.createElement(Skeleton, {
  bottomMargin: 1,
  boxHeight: 1,
  boxWidthProcent: 100,
  topMargin: 1
}), React.createElement(Skeleton, {
  bottomMargin: 1,
  boxHeight: 1,
  boxWidthProcent: 100,
  topMargin: 1
})), React.createElement(React.Fragment, null, React.createElement(Skeleton, {
  bottomMargin: 0,
  boxHeight: 2,
  boxWidthProcent: 100,
  topMargin: 2
}), React.createElement(Skeleton, {
  bottomMargin: 0,
  boxHeight: 3,
  boxWidthProcent: 100,
  topMargin: 2
}), React.createElement(Skeleton, {
  bottomMargin: 0,
  boxHeight: 1,
  boxWidthProcent: 100,
  topMargin: 1
})));
svs.myProfile.react.pages.communicationSettings.communicationSettings.components.CommunicationSettingsSkeleton = CommunicationSettingsSkeleton;

 })(window);